import { AllowedCountry } from '@models/allowedCountry';
import { countryConfig, CountryKey } from '@core/country/country';

const allowedCountryKeys: Array<CountryKey.KZ | CountryKey.KG | CountryKey.UZ | CountryKey.TJ> = [
  CountryKey.KZ,
  CountryKey.KG,
  CountryKey.UZ,
  CountryKey.TJ,
];

export const allowedCountries: AllowedCountry[] = allowedCountryKeys.map((key) => {
  const country = countryConfig[key];
  const { label, phone, currency, geoEnum } = country;

  return {
    name: label,
    currencyCode: currency.code,
    currencyName: currency.name,
    currencySymbol: currency.symbol,
    currencyId: currency.id,
    countryCode: geoEnum,
    mask: phone.mask,
    prefix: phone.prefix,
  };
});
